import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';

import ApiDirector from './ApiDirector';
import { MediumGreen } from './Styles';
import { iconMap } from '../containers/MarketDetail';

const ProductAvatar = withStyles({
  avatarIconMap: {
    width: '75px',
    height: '75px',
    marginRight: '1rem',
    border: `0.2rem solid ${MediumGreen}`,
  },
  avatar: {
    width: '75px',
    height: '75px',
    marginRight: '1rem',
  },
})(({ classes, product, productCategory }) => {
  let source = null;
  let aClass = null;
  const url = product.avatar_thumb || 'missing.png';
  if (url.indexOf('missing.png') !== -1) {
    source = iconMap[productCategory.name];
    aClass = classes.avatarIconMap;
  } else {
    source = ApiDirector.imageUrl(url);
    aClass = classes.avatar;
  }
  return (
    <Avatar alt={product.name} src={source} className={aClass} />
  );
});

export default ProductAvatar;
